import React, { useState } from 'react';
import { formatWorkshopMeetingLine } from '../../services/workshop2026Service';
import { Meeting } from '../../services/meetingService';
import styles from '../../styles/workshop2026Page.module.css';

interface WorkshopZoomBlockProps {
  meeting: Meeting | null;
  zoomUrl?: string;
  locked?: boolean;
  sectionId?: string;
}

const WorkshopZoomBlock: React.FC<WorkshopZoomBlockProps> = ({
  meeting,
  zoomUrl,
  locked = false,
  sectionId,
}) => {
  const [copied, setCopied] = useState(false);
  const meetingLine = formatWorkshopMeetingLine(meeting);
  const url = (zoomUrl || meeting?.zoom_url || '').trim();

  const handleCopy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  };

  if (locked) {
    return (
      <section id={sectionId} className={styles.zoomBlockFeatured}>
        <h3 className={styles.sectionSubheading}>Join live · Zoom</h3>
        <p className={styles.zoomSchedule}>{meetingLine}</p>
        <p className={styles.helperText}>
          Available after you confirm you&apos;re planning to attend.
        </p>
      </section>
    );
  }

  return (
    <section id={sectionId} className={styles.zoomBlockFeatured}>
      <h3 className={styles.sectionSubheading}>Join live · Zoom</h3>
      <p className={styles.zoomSchedule}>{meetingLine}</p>
      {url ? (
        <>
          <div className={styles.zoomActions}>
            <a href={url} target="_blank" rel="noopener noreferrer" className={styles.primaryBtn}>
              Open Zoom meeting
            </a>
            <button type="button" className={styles.secondaryBtn} onClick={handleCopy}>
              {copied ? 'Copied!' : 'Copy link'}
            </button>
          </div>
          <p className={styles.helperText}>Link includes pass phrase.</p>
        </>
      ) : (
        <p className={styles.zoomPlaceholder}>
          Zoom link will appear here before the first session.
        </p>
      )}
    </section>
  );
};

export default WorkshopZoomBlock;
